import React from 'react';
import ReactDOM from 'react-dom/client'; // Use 'react-dom/client' for React 18
import './webflow.css';
import './balanz.webflow.css';
import './normalize.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; //theme
import 'primereact/resources/primereact.min.css'; //core css
import 'primeicons/primeicons.css'; //icons
import { getToken } from './utils/authCrypto';
import { setupAxiosInterceptors } from './api/axiosInterceptor';


axios.defaults.baseURL = process.env.REACT_APP_API || 'http://localhost:3001/api';
axios.defaults.withCredentials = true;

const token = getToken()

if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
} else {
  delete axios.defaults.headers.common['Authorization']
}

setupAxiosInterceptors()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_ROUTE}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
